import React from "react";
import styled from "styled-components";
import logoImage from "../../../../images/logo.svg";

const Header = ({ className }) => (
  <Container className={className}>
    <LogoContainer>
      <Logo />
    </LogoContainer>
  </Container>
);

const Container = styled.div`
  width: 100%;
  background-image: linear-gradient(#ff2327, #e91d4e);
  padding: 23px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoContainer = styled.a.attrs({ href: "/" })`
  display: block;
  margin: 0;
  height: 12px;
`;

const Logo = styled.img.attrs({ src: logoImage })`
  width: 100px;
  height: auto;
`;

export default Header;
